import { cn } from '@dnx/ui';
import { initials } from '../lib/labels.js';

/** Monograma na cor da marca da clínica — reconhecimento rápido na lista. */
export function OrgAvatar({ name, color, size = 'md' }: { name: string; color: string; size?: 'md' | 'lg' }) {
  const clean = name.replace(/^(cl[ií]nica|instituto|centro)\s+/i, '');
  return (
    <span aria-hidden style={{ background: color }}
      className={cn('grid shrink-0 place-items-center font-semibold text-white shadow-card',
        size === 'lg' ? 'size-12 rounded-xl text-base' : 'size-8 rounded-lg text-[11px]')}>
      {initials(clean)}
    </span>
  );
}
